
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { tables } from "@/lib/supabase";
import { Location } from "@/types/locationTypes";
import { useAuth } from "@/hooks/useAuth";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { MapPin } from "lucide-react";

interface StaffLocationFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const StaffLocationFilter: React.FC<StaffLocationFilterProps> = ({
  value,
  onChange,
}) => {
  const { organizationId } = useAuth();

  const { data: locations = [], isLoading } = useQuery({
    queryKey: ['locations'],
    queryFn: async () => {
      const { data, error } = await tables.locations()
        .select('*')
        .eq('organization_id', organizationId || '');
        
      if (error) throw error;
      return data as Location[];
    },
    enabled: !!organizationId,
  });

  return (
    <div className="flex items-center gap-2">
      <MapPin className="h-4 w-4 text-muted-foreground" />
      <Select
        value={value}
        onValueChange={onChange}
        disabled={isLoading || locations.length === 0}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Filter by location" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Locations</SelectItem>
          {locations.map((location) => (
            <SelectItem key={location.id} value={location.id}>
              {location.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default StaffLocationFilter;
